///<reference path="../common/custom-validation.model.ts"/>
///<reference path="../common/custom-validation-base.ts"/>
///<reference path="../common/collection.model.ts"/>

module Meevo.Components.Controls.SmartMover {

    export class RequiredIfAllUnselectedValidation extends CustomValidationBase implements ICustomValidation {

        readonly message?: string;

        get placement(): ErrorMessagePlacements {
            return 'top';
        }

        get valid(): boolean {
            if (this.getAllSelected()) {
                return true;
            }

            return this.collection.selectedModels.length > 0;
        }

        constructor(
            private collection: ICollectionBase<any>,
            private getAllSelected: () => boolean,
            message?: string
        ) {
            super();

            this.message = message;
        }
    }
}
